'use client';

import { ICard } from '$components/Card';
import FadeInSection from '$components/FadeInSection/FadeInSection';
import { LogoBanner, LogoData } from '$components/LogoBanner';
import { TypeAssetFragment } from '$contentful-gql/graphql';
import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

function Section(props: PropsWithChildren<{ columns?: string }>) {
  const { children, columns = '2' } = props;

  function extractLogoFromAsset(asset: TypeAssetFragment): LogoData | null {
    if (asset.image) {
      return {
        // @ts-ignore ignore for now until we move to a provider that types this correctly
        alt: asset.image.description,
        // @ts-ignore
        title: asset.image.title,
        // @ts-ignore
        url: asset.image.url,
      };
    }
    return null;
  }

  // This was added to work around a content type limitation of the current plan,
  // https://github.com/ZeroPetroleum/zeropetroleum/issues/324
  // Extract the assets from cards when the logo banner is defined for the column structure
  // TODO extract to a provider and do correctly
  const extractLogoDataFromCards = () => {
    const allLogos = [];

    React.Children.forEach(children, (child) => {
      if (React.isValidElement<ICard>(child)) {
        const { props } = child;

        // If a background asset has been set, extract it
        if (props.asset) {
          const logo = extractLogoFromAsset(props.asset);
          if (logo) allLogos.push(logo);
        }

        // If the assets have been defined as an array of assets, use them
        if (props.assets) {
          props.assets.forEach((asset) => {
            const logo = extractLogoFromAsset(asset);
            if (logo) allLogos.push(logo);
          });
        }
      }
    });

    return allLogos;
  };

  // Extract the logo data if the 'columns' prop indicates a banner should be displayed
  const logoData = columns === 'logoBanner' ? extractLogoDataFromCards() : [];

  return (
    <>
      {/*
      This was added to work around a content type limitation of the current plan,
      https://github.com/ZeroPetroleum/zeropetroleum/issues/324
      */}
      {columns === 'logoBanner' ? (
        <div className="grid-standard">
          <div className="col-span-4 lg:col-span-12">
            <FadeInSection>
              <LogoBanner logoData={logoData} />
            </FadeInSection>
          </div>
        </div>
      ) : (
        <div
          className={`grid-standard md:!grid-cols-12 lg:!grid-cols-[repeat(12,_minmax(0px,_116px))]`}
        >
          {React.Children.map(children, (child, index) => {
            return (
              <div
                key={index}
                className={cn(
                  columns === '2' && `col-span-4 md:col-span-6`,
                  columns === '3' && `col-span-4 md:col-span-4`,
                )}
              >
                {child}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default Section;
